import React, { useEffect, useState } from "react";
import axios from "axios";

import { Container, Box, Typography, Tabs, Tab, Paper } from "@mui/material";

import { Description, PhotoLibrary } from "@mui/icons-material";

import ArticleIcon from "@mui/icons-material/Article";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import StackedBarChartIcon from "@mui/icons-material/StackedBarChart";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollTopButton from "../../components/ScrollTopButton";

import Tablelist from "./components/Tablelist";
import Medialist from "./components/Medialist";

const Manage = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3001/api/";
  } else {
    xURL = "https://sau.rihes.cmu.ac.th/api/";
  }

  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex2, setTabIndex2] = useState(0);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
  };
  const handleTabChange2 = (event, newIndex) => {
    setTabIndex2(newIndex);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      console.warn("❌ Token ไม่พบใน localStorage");
      window.location = "/login";
      return;
    }

    axios
      .post(
        xURL + "authen",
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      )
      .then(result => {
        if (result.data.status === "ok") {
          //   alert("authen sucess");
        } else {
          //alert("authen failed");
          localStorage.removeItem("token");
          window.location = "/login";
        }
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  }, []);

  return (
    <React.Fragment>
      <Navbar />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: "#F9F9F9", // พื้นหลังสีขาวนวล
          color: "#333",
          p: 4
        }}
      >
        <Container sx={{ textAlign: "center", maxWidth: "md" }}>
          <Typography
            gutterBottom
            sx={{
              mt: 15,
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              textAlign: "center",
              fontSize: { xs: "1.8rem", sm: "2rem", md: "2rem" },
              color: "#333",
              letterSpacing: "1px",
              lineHeight: 1.4
            }}
          >
            📂 จัดการข้อมูล
          </Typography>

          {/* Tabs */}
          <Paper
            elevation={3}
            sx={{
              mt: 4,
              borderRadius: 3,
              overflow: "hidden",
              backgroundColor: "white"
            }}
          >
            <Tabs
              value={tabIndex}
              onChange={handleTabChange}
              centered
              variant="fullWidth"
              sx={{
                "& .MuiTab-root": {
                  color: "#555",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  transition: "0.3s"
                },
                "& .MuiTab-root.Mui-selected": {
                  color: "#3F51B5"
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "#3F51B5",
                  height: 4,
                  borderRadius: 2
                }
              }}
            >
              <Tab icon={<Description />} label="เอกสาร" />
              <Tab icon={<PhotoLibrary />} label="สื่อ" />
            </Tabs>
          </Paper>

          {/* Tab Content */}
          <Box
            sx={{
              mt: 4,
              p: 3,
              borderRadius: 3,
              backgroundColor: "white",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.1)"
            }}
          >
            {tabIndex === 0 &&
              <div>
                <Tabs
                  value={tabIndex2}
                  onChange={handleTabChange2}
                  // centered
                  // variant="fullWidth"
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    "& .MuiTab-root": {
                      color: "#555",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                      transition: "0.3s"
                    },
                    "& .MuiTab-root.Mui-selected": {
                      color: "#3F51B5"
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#3F51B5",
                      height: 2,
                      borderRadius: 2
                    }
                  }}
                >
                  <Tab icon={<ArticleIcon />} label="รายงานวิจัย" />
                  <Tab
                    icon={<HistoryEduIcon />}
                    label="บทความ / บทสรุปผู้บริหาร"
                  />
                  <Tab icon={<MenuBookIcon />} label="หนังสือ" />
                  <Tab icon={<StackedBarChartIcon />} label="Infographic" />
                  <Tab icon={<SportsEsportsIcon />} label="เกม" />
                </Tabs>

                <div style={{ height: "15px" }} />

                {tabIndex2 === 0 && <Tablelist taborder={1} />}
                {tabIndex2 === 1 && <Tablelist taborder={2} />}
                {tabIndex2 === 2 && <Tablelist taborder={3} />}
                {tabIndex2 === 3 && <Tablelist taborder={4} />}
                {tabIndex2 === 4 && <Tablelist taborder={5} />}
              </div>}

            {tabIndex === 1 &&
              <Typography fontSize="1.2rem">
                <Medialist />
              </Typography>}
          </Box>
        </Container>

        <ScrollTopButton />
      </Box>

      <Footer />
    </React.Fragment>
  );
};

export default Manage;
